// Interface

import util from '@/utils/classToObject'
import { IMapLayerState } from './state'
import { AloDbMapLayer } from '@/models/alodb/AloDbMapLayer'
import { toNumberDictionary } from '@/utils/groupBy'

export class MapLayerGetter {  
      
  public mapLayers(state:IMapLayerState,getters:any) {
    return state.mapLayers.sort((a,b) => (a.libelle??"").localeCompare(b.libelle ?? ""))
  }

  public mapLayersDic(state:IMapLayerState,getters:any) {
    return toNumberDictionary(state.mapLayers, l => l.id!)
  }  

  public modifiedAdmMapLayer(state:IMapLayerState,getters:any) {
    return state.modifiedAdmMapLayer
  }

  public originalAdmMapLayer(state:IMapLayerState,getters:any) {
    return state.originalAdmMapLayer
  }

  public mapLayerLoading(state:IMapLayerState,getters:any) {
    return state.mapLayerLoading
  }

  public mapLayersById(state:IMapLayerState) {     
    return state.mapLayers.reduce((acc,value) =>{
        acc[value.LAY_ID!] = value
        return acc
    },{}  as {[id:number]:AloDbMapLayer})      
  }

  public mapLayerStatus(state:IMapLayerState) {     
    return state.status
  }

  public adminMapLayerFilter(state:IMapLayerState) {     
    return state.adminFilter
  }
  
}

export default util.classToObject(MapLayerGetter)